import React from "react";

const Services = ({ id }) => {
  const videoSrc = "https://www.youtube.com/embed/1szmTBugWjU"; // Enlace de YouTube

  return (
    <section id={id} style={styles.section}>
      <h2 style={styles.heading}>Servicios de la consultoría</h2>

      <ol style={styles.list} className="custom-counter">
        <li style={styles.listItem}>
          Realizar análisis de prácticas DEI para empresas, gobierno,
          instituciones educativas o de asociaciones civiles.
        </li>
        <li style={styles.listItem}>
          Desarrollar políticas y estrategias para incrementar la diversidad y
          mejorar la equidad y la inclusión.
        </li>
        <li style={styles.listItem}>
          Talleres en diversidad, equidad e inclusión.
        </li>
      </ol>
      <div style={styles.videoContainer}>
        <iframe
          width="100%"
          height="600"
          src={videoSrc}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "20px",
    backgroundColor: "#ffffff",
  },
  heading: {
    textAlign: "right",
    fontFamily: "Outfit, sans-serif",
    color: "#AC4896",
    fontSize: "3rem",
    marginBottom: "20px",
  },
  videoContainer: {
    textAlign: "center",
    marginTop: "70px",
  },
  previewImage: {
    width: "100%",
    borderRadius: "10px",
  },
  playButton: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(0, 0, 0, 0.6)",
    color: "white",
    fontSize: "3rem",
    borderRadius: "50%",
    padding: "10px 20px",
  },
  list: {
    fontSize: "1.2rem",
    lineHeight: "1.6",
    marginTop: "5rem",
    listStyleType: "none",
  },
  listItem: {
    counterIncrement: "step-counter",
    marginBottom: "20px",
    fontFamily: "Outfit, serif",
    fontWeight: "250",
    fontSize: "2rem",
    position: "relative",
    paddingLeft: "6rem",

    textAlign: "justify",
  },
};

export default Services;
